export const clone = (objectOrArray) => Array.isArray(objectOrArray)
    ? objectOrArray.map(item => clone(item))
    : { ...objectOrArray };